import { render, staticRenderFns } from "./FormInputGroupMerged.vue?vue&type=template&id=60d686f4"
import script from "./FormInputGroupMerged.vue?vue&type=script&lang=js"
export * from "./FormInputGroupMerged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports